export default "__VITE_ASSET__pFJRJAgO__"